// import React, { useEffect } from 'react';
// import * as am5 from '@amcharts/amcharts5';
// import * as am5percent from '@amcharts/amcharts5/percent';
// import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

// const FunnelChart = () => {
//   useEffect(() => {
//     // Dispose of any existing root elements
//     if (am5.registry.rootElements.length > 0) {
//       am5.registry.rootElements.forEach((root) => root.dispose());
//     }

//     // Create root element
//     const root = am5.Root.new('chartdiv');

//     // Remove amCharts logo
//     root._logo.dispose();

//     // Set themes
//     root.setThemes([am5themes_Animated.new(root)]);

//     // Create chart
//     const chart = root.container.children.push(
//       am5percent.SlicedChart.new(root, {
//         layout: root.verticalLayout,
//       })
//     );

//     // Create series
//     const series = chart.series.push(
//       am5percent.FunnelSeries.new(root, {
//         alignLabels: false,
//         orientation: 'horizontal',
//         valueField: 'value',
//         categoryField: 'category',
//         bottomRatio: 1,
//       })
//     );

//     // Set data
//     series.data.setAll([
//       { value: 10, category: 'One' },
//       { value: 9, category: 'Two' },
//       { value: 6, category: 'Three' },
//       { value: 5, category: 'Four' },
//       { value: 4, category: 'Five' },
//       { value: 3, category: 'Six' },
//       { value: 1, category: 'Seven' },
//     ]);

//     // Play initial series animation
//     series.appear();

//     // Create legend
//     const legend = chart.children.push(
//       am5.Legend.new(root, {
//         centerX: am5.p50,
//         x: am5.p50,
//         marginTop: 15,
//         marginBottom: 15,
//       })
//     );

//     legend.data.setAll(series.dataItems);

//     // Animate the chart on load
//     chart.appear(1000, 100);

//     // Cleanup on component unmount
//     return () => {
//       root.dispose();
//     };
//   }, []);

//   return <div id="chartdiv" style={{ width: '100%', height: '500px' }}></div>;
// };

// export default FunnelChart;



import React, { useEffect } from 'react';
import * as am5 from '@amcharts/amcharts5';
import * as am5percent from '@amcharts/amcharts5/percent';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

const FunnelChart = () => {
  useEffect(() => {
    const root = am5.Root.new('funnelChartDiv');
    root.setThemes([am5themes_Animated.new(root)]);

    const chart = root.container.children.push(
      am5percent.SlicedChart.new(root, { layout: root.verticalLayout })
    );

    const series = chart.series.push(
      am5percent.FunnelSeries.new(root, {
        alignLabels: false,
        orientation: 'horizontal',
        valueField: 'value',
        categoryField: 'category',
        bottomRatio: 1
      })
    );

    series.data.setAll([
      { value: 10, category: 'One' },
      { value: 9, category: 'Two' },
      { value: 6, category: 'Three' },
      { value: 5, category: 'Four' },
      { value: 4, category: 'Five' },
      { value: 3, category: 'Six' },
      { value: 1, category: 'Seven' }
    ]);

    return () => root.dispose();
  }, []);

  return <div id="funnelChartDiv" style={{ width: '100%', height: '400px' }}></div>;
};

export default FunnelChart;

